import React, {useState, useEffect, useContext} from 'react'
import {Modal, Button, Row, Col, Form, Card, Spinner} from 'react-bootstrap';
import {NotificationManager} from 'react-notifications'
import moment from 'moment';
import { FaCalendarAlt, FaUser, FaArrowRight, FaArrowLeft, FaClock, FaMapMarkerAlt, FaCheck, FaTimes, FaTrash, FaSave } from 'react-icons/fa';

import "react-datepicker/dist/react-datepicker.css";
import '../styles/PopupTraveller.css';

import {AppContext} from '../AppContext';
import {tre} from '../trebus'
import SelectStop from './../components/SelectStop'

export default function PopupTraveller(
    {
        open = true,
        date, // Y-m-d
        idTravellerGo,
        idTravellerCome,
        idUser,
        onClose,
        onUpdateUser,
        onUpdateTraveller
    }
) {

    const context = useContext(AppContext);
    const [trips, setTrips] = useState();
    const [user, setUser] = useState();
    const [newUserName, setNewUserName] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    // Traveller GO
    const [travellerGo, setTravellerGo] = useState();
    const [tripGoId, setTripGoId] = useState(0);
    const [stopGoId, setStopGoId] = useState(0);
    const [rateGo, setRateGo] = useState();

    // Traveller COME
    const [travellerCome, setTravellerCome] = useState();
    const [tripComeId, setTripComeId] = useState(0);
    const [stopComeId, setStopComeId] = useState(0);
    const [rateCome, setRateCome] = useState();

    /**
     * Load traveller GO and COME
     */
    const loadTraveller = (direction = 'GO') => {
        tre.api('GET', '/travellers/' + (direction === 'GO' ? idTravellerGo : idTravellerCome), {
            context: context,
            success: (r) => {

                // GO
                if (direction === 'GO') {

                    setTravellerGo(r);
                    setTripGoId(r.trip.id)
                    setStopGoId(r.start.id)
                    if (r.rate) setRateGo(r.rate);

                    // COME
                } else {

                    setTravellerCome(r);
                    setTripComeId(r.trip.id)
                    setStopComeId(r.start.id)
                    if (r.rate) setRateCome(r.rate);
                }
            }
        });
    }

    /**
     * Obtener datos del usuario
     */
    const loadUser = () => {
        tre.api('GET', '/users/' + idUser, {
            context: context,
            success: (r) => {
                setUser(r);
            }
        });
    }

    /**
     * Obtener viajes de ida y de vuelta de un día
     */
    const loadTrips = () => {
        console.log('PopupTraveller.js: Getting trip joirneys ...');
        tre.api('GET', '/trips/journeys', {
            context: context,
            params: {
                date: date,
                //direction: 'COME'
            },
            success: (r) => {
                setTrips(r);
            }
        });
    }

    /**
     * Init travellers: traveller id changes
     */
    useEffect(() => {

        // Load traveller GO
        if (idTravellerGo) loadTraveller('GO')
        else {

            // Default going
            setTravellerGo({trip: {}})
            setStopGoId(user && user.go ? user.go.id : 0)
            setTripGoId(0)
            setRateGo(null)
        }

        // Load traveller COME
        if (idTravellerCome) loadTraveller('COME')
        else {

            // Default coming
            setTravellerCome({trip: {}})
            setStopComeId(user && user.come ? user.come.id : 0)
            setTripComeId(0)
            setRateCome(null)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idTravellerGo, idTravellerCome])

    /**
     * Create user
     */
    const createUser = () => {
        setIsSaving(true);
        tre.api('POST', '/companies/' + context.idCompany + '/users', {
            context: context,
            params: {
                name: newUserName,
                //go: {id: idStart},
                //come: {id: idEnd},
            },
            success: (r) => {
                setUser(r)
                onUpdateUser(r)
                setIsSaving(false);
            },
            error: () => setIsSaving(false)
        });
    }

    /**
     * Save traveller
     */
    const saveTraveller = (direction = 'GO') => {

        let traveller, idStart, idEnd, idTrip;
        if (direction === 'GO') {
            traveller = travellerGo;
            idTrip = tripGoId;
            idStart = stopGoId;
            idEnd = stopComeId;
        } else {
            traveller = travellerCome;
            idTrip = tripComeId;
            idStart = stopComeId;
            idEnd = stopGoId;
        }

        if (idStart && idEnd && idTrip) {

            // Updating
            if (traveller.id) {

                tre.api('PUT', '/travellers/' + traveller.id, {
                    context: context,
                    params: {
                        idTrip: idTrip,
                        idStart: idStart,
                        idEnd: idEnd,
                        idTripReturn: direction === 'GO' ? tripComeId : null,
                    },
                    success: () => {
                        NotificationManager.success('Guardado')
                        onUpdateTraveller()
                        onClose()
                        setIsSaving(false);
                    },
                    error: () => setIsSaving(false)
                });

                // Creating
            } else {

                tre.api('POST', '/trips/' + idTrip + '/users/' + user.id, {
                    context: context,
                    params: {
                        idStart: idStart,
                        idEnd: idEnd,
                        //idTripReturn: direction=='GO' ? tripComeId : null,
                    },
                    success: () => {
                        NotificationManager.success('Guardado')
                        onUpdateTraveller()
                        onClose()
                        setIsSaving(false);
                    },
                    error: () => setIsSaving(false)
                });
            }
        }

        if (direction === 'GO') {
            saveTraveller('COME')
        }
    }

    /**
     * On save
     */
    const onSave = () => {
        setIsSaving(true);
        saveTraveller('GO')
        //saveTraveller('COME')
    }

    /**
     * Toggle confirm
     */
    const toggleConfirm = (traveller) => {
        tre.api('PUT', '/travellers/' + traveller.id, {
            context: context,
            params: {
                confirmed: traveller.confirmed ? 0 : 1
            },
            success: () => {
                NotificationManager.success('Guardado')
                loadTraveller('GO')
                loadTraveller('COME')
            }
        });
    }

    /**
     * Delete traveller
     */
    const deleteTraveller = (direction) => {

        let idTraveller = (direction === 'GO' ? idTravellerGo : idTravellerCome)
        if (idTraveller) {
            tre.api('DELETE', '/travellers/' + idTraveller, {
                context: context,
                confirmation: true,
                success: () => {
                    NotificationManager.success('Eliminado')
                    onUpdateTraveller()
                    onClose()
                    setIsDeleting(false);
                },
                error: () => setIsDeleting(false)
            });
        }
    }

    /**
     * Delete traveller
     */
    const removeBothDirections = () => {
        setIsDeleting(true);
        deleteTraveller('GO')
        deleteTraveller('COME')
    }

    /**
     * User id changes
     */
    useEffect(() => {
        if (idUser) loadUser()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idUser])

    /**
     * Date changes
     */
    useEffect(() => {

        loadTrips()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [date])

    // Render
    return (
        <Modal size="lg" show={open} onHide={onClose} centered className="traveller-modal">
            <Modal.Header
                closeButton
                style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    borderRadius: '0'
                }}
            >
                <Modal.Title className="text-white d-flex align-items-center">
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle me-3"
                        style={{ width: '40px', height: '40px', background: 'rgba(255,255,255,0.2)' }}
                    >
                        <FaCalendarAlt size={18} />
                    </div>
                    Viaje de ida y vuelta
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="p-4">
                {/* Date and User Info Card */}
                <Card
                    className="border-0 mb-4"
                    style={{
                        borderRadius: '12px',
                        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                        background: 'linear-gradient(135deg, #f8f9fa 0%, #fff 100%)'
                    }}
                >
                    <Card.Body className="py-3">
                        <Row className="align-items-center">
                            <Col md={6} className="d-flex align-items-center mb-2 mb-md-0">
                                <div
                                    className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                    style={{
                                        width: '44px',
                                        height: '44px',
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        flexShrink: 0
                                    }}
                                >
                                    <FaCalendarAlt className="text-white" size={18} />
                                </div>
                                <div>
                                    <small className="text-muted d-block">Fecha</small>
                                    <strong style={{ color: '#333', fontSize: '1.1rem' }}>
                                        {moment(date).format('D [de] MMMM [de] YYYY')}
                                    </strong>
                                </div>
                            </Col>
                            {user && (
                                <Col md={6} className="d-flex align-items-center">
                                    <div
                                        className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                        style={{
                                            width: '44px',
                                            height: '44px',
                                            background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                            color: '#fff',
                                            fontSize: '1.1rem',
                                            fontWeight: 600,
                                            flexShrink: 0
                                        }}
                                    >
                                        {(user.name || '?').charAt(0).toUpperCase()}
                                    </div>
                                    <div>
                                        <small className="text-muted d-block">Pasajero</small>
                                        <strong style={{ color: '#333', fontSize: '1.1rem' }}>
                                            {user.surname ? `${user.surname}, ${user.name}` : user.name}
                                        </strong>
                                    </div>
                                </Col>
                            )}
                        </Row>
                    </Card.Body>
                </Card>

                {/* New User Section */}
                {!user && (
                    <Card
                        className="border-0 mb-4"
                        style={{
                            borderRadius: '12px',
                            background: 'linear-gradient(135deg, #fff9e6 0%, #fff 100%)',
                            borderLeft: '4px solid #ffc107'
                        }}
                    >
                        <Card.Body className="p-4">
                            <div className="d-flex align-items-center mb-3">
                                <div
                                    className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                    style={{ width: '36px', height: '36px', background: '#ffc107' }}
                                >
                                    <FaUser className="text-white" size={14} />
                                </div>
                                <h5 className="mb-0" style={{ color: '#856404' }}>Crear Nuevo Cliente</h5>
                            </div>
                            <p className="text-muted small mb-3">
                                Al no seleccionar a un cliente puede introducir aquí el nombre y al crear el viaje se creará
                                automáticamente un cliente con el nombre introducido.
                                Esto es útil para clientes esporádicos.
                            </p>
                            <Form.Group>
                                <Form.Label style={{ color: '#856404', fontWeight: 500 }}>Nombre del Cliente</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="newUserName"
                                    value={newUserName}
                                    onChange={ev => setNewUserName(ev.target.value)}
                                    placeholder="Ingrese el nombre del cliente"
                                    style={{ borderRadius: '8px' }}
                                />
                            </Form.Group>
                        </Card.Body>
                    </Card>
                )}

                {/* Direction Cards */}
                {user && (
                    <>
                        <PopupTravellerDirection
                            direction="GO"
                            trips={trips && trips.filter(trip => trip.route.direction === 'GO')}
                            traveller={travellerGo}
                            idTrip={tripGoId}
                            idStop={stopGoId}
                            rate={rateGo}
                            onChangeTripId={setTripGoId}
                            onChangeStopId={setStopGoId}
                            onToggleConfirm={toggleConfirm}
                        />

                        <PopupTravellerDirection
                            direction="COME"
                            trips={trips && trips.filter(trip => trip.route.direction === 'COME')}
                            traveller={travellerCome}
                            idTrip={tripComeId}
                            idStop={stopComeId}
                            rate={rateCome}
                            onChangeTripId={setTripComeId}
                            onChangeStopId={setStopComeId}
                            onToggleConfirm={toggleConfirm}
                        />
                    </>
                )}
            </Modal.Body>

            <Modal.Footer style={{ borderTop: '1px solid #e9ecef', background: '#f8f9fa' }}>
                <div className="d-flex justify-content-between w-100">
                    <div>
                        {((travellerGo && travellerGo.id) || (travellerCome && travellerCome.id)) && (
                            <Button
                                onClick={() => removeBothDirections()}
                                disabled={isDeleting}
                                style={{
                                    background: 'linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '10px 20px',
                                    fontWeight: 500
                                }}
                            >
                                {isDeleting ? (
                                    <Spinner animation="border" size="sm" className="me-2" />
                                ) : (
                                    <FaTrash className="me-2" />
                                )}
                                Eliminar
                            </Button>
                        )}
                    </div>

                    <div className="d-flex gap-2">
                        <Button
                            variant="outline-secondary"
                            onClick={onClose}
                            style={{
                                borderRadius: '8px',
                                padding: '10px 20px',
                                fontWeight: 500
                            }}
                        >
                            <FaTimes className="me-2" />
                            Cerrar
                        </Button>

                        {(user && ((tripGoId > 0 && stopGoId > 0) || (tripComeId > 0 && stopComeId > 0))) && (
                            <Button
                                onClick={() => onSave()}
                                disabled={isSaving}
                                style={{
                                    background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '10px 24px',
                                    fontWeight: 500
                                }}
                            >
                                {isSaving ? (
                                    <Spinner animation="border" size="sm" className="me-2" />
                                ) : (
                                    <FaSave className="me-2" />
                                )}
                                Guardar
                            </Button>
                        )}

                        {!user && newUserName && (
                            <Button
                                onClick={() => createUser()}
                                disabled={isSaving}
                                style={{
                                    background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '10px 24px',
                                    fontWeight: 500
                                }}
                            >
                                {isSaving ? (
                                    <Spinner animation="border" size="sm" className="me-2" />
                                ) : (
                                    <FaUser className="me-2" />
                                )}
                                Crear Cliente
                            </Button>
                        )}
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

/**
 * Go and come direction card
 */
function PopupTravellerDirection({
    direction,
    trips,
    traveller,
    idTrip,
    idStop,
    rate,
    onChangeTripId,
    onChangeStopId,
    onToggleConfirm
}) {
    const context = useContext(AppContext);
    const isGo = direction === 'GO';

    const gradientColor = isGo
        ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        : 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)';

    const borderColor = isGo ? '#667eea' : '#11998e';
    const labelColor = isGo ? '#667eea' : '#11998e';

    return (
        <Card
            className="border-0 mb-3"
            style={{
                borderRadius: '12px',
                boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                borderLeft: `4px solid ${borderColor}`
            }}
        >
            <Card.Body className="p-4">
                {/* Direction Header */}
                <div className="d-flex align-items-center mb-4">
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle me-3"
                        style={{
                            width: '36px',
                            height: '36px',
                            background: gradientColor
                        }}
                    >
                        {isGo ? (
                            <FaArrowRight className="text-white" size={14} />
                        ) : (
                            <FaArrowLeft className="text-white" size={14} />
                        )}
                    </div>
                    <h5 className="mb-0" style={{ color: labelColor, fontWeight: 600 }}>
                        {isGo ? 'IDA' : 'VUELTA'}
                    </h5>
                    {traveller && traveller.confirmed && (
                        <span
                            className="ms-auto d-flex align-items-center"
                            style={{
                                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                color: '#fff',
                                padding: '6px 12px',
                                borderRadius: '20px',
                                fontSize: '0.8rem',
                                fontWeight: 500
                            }}
                        >
                            <FaCheck className="me-1" size={10} />
                            Confirmado
                        </span>
                    )}
                </div>

                {/* Form Fields */}
                <Row className="g-3 align-items-end">
                    <Col md={rate ? 4 : 6}>
                        <Form.Label className="d-flex align-items-center mb-2" style={{ color: '#6c757d', fontWeight: 500 }}>
                            <FaClock className="me-2" style={{ color: labelColor }} />
                            Hora de Salida
                        </Form.Label>
                        <Form.Select
                            value={idTrip}
                            onChange={ev => onChangeTripId(ev.target.value)}
                            style={{
                                borderRadius: '8px',
                                border: '1px solid #e9ecef',
                                padding: '10px 12px'
                            }}
                        >
                            <option value={0}>Seleccionar hora</option>
                            {trips && trips.map(trip =>
                                <option
                                    key={trip.id}
                                    value={trip.id}>
                                    {moment(trip.route.departure, 'HH:mm:00').format('HH:mm')}
                                </option>
                            )}
                        </Form.Select>
                    </Col>

                    <Col md={rate ? 5 : 6}>
                        <Form.Label className="d-flex align-items-center mb-2" style={{ color: '#6c757d', fontWeight: 500 }}>
                            <FaMapMarkerAlt className="me-2" style={{ color: labelColor }} />
                            Punto de Salida
                        </Form.Label>
                        <SelectStop
                            value={idStop}
                            onChange={(idStop) => onChangeStopId(idStop)}
                        />
                    </Col>

                    {rate && (
                        <Col md={3}>
                            <Form.Label className="d-flex align-items-center mb-2" style={{ color: '#6c757d', fontWeight: 500 }}>
                                <span className="me-2" style={{ color: labelColor, fontWeight: 600 }}>€</span>
                                Tarifa
                            </Form.Label>
                            <div
                                style={{
                                    background: '#f8f9fa',
                                    borderRadius: '8px',
                                    padding: '10px 12px',
                                    textAlign: 'right',
                                    fontWeight: 600,
                                    color: labelColor,
                                    fontSize: '1.1rem'
                                }}
                            >
                                {parseFloat(rate.price).toFixed(2)} €
                            </div>
                        </Col>
                    )}
                </Row>

                {/* Confirmation Toggle */}
                {traveller && traveller.id && context.user.role !== 'USER' && (
                    <div className="mt-4 pt-3" style={{ borderTop: '1px solid #e9ecef' }}>
                        <Button
                            onClick={() => onToggleConfirm(traveller)}
                            style={{
                                background: traveller.confirmed
                                    ? '#f8f9fa'
                                    : 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                border: traveller.confirmed ? '2px solid #e9ecef' : 'none',
                                borderRadius: '8px',
                                padding: '10px 20px',
                                color: traveller.confirmed ? '#6c757d' : '#fff',
                                fontWeight: 500,
                                width: '100%'
                            }}
                        >
                            {traveller.confirmed ? (
                                <>
                                    <FaTimes className="me-2" />
                                    Deshacer confirmación
                                </>
                            ) : (
                                <>
                                    <FaCheck className="me-2" />
                                    Confirmar viaje
                                </>
                            )}
                        </Button>
                    </div>
                )}
            </Card.Body>
        </Card>
    )
}
